import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { setLocale } from 'store/state/locale/localeActions';

import { LocaleDropdown } from './LocaleDropdown';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChangeLocale: (locale: string) => dispatch(setLocale(locale)),
});

export const LocaleDropdownContainer = compose(connect(undefined, mapDispatchToProps))(LocaleDropdown);
